




















import { Component, Prop, Vue } from 'vue-property-decorator'
import VueTextareaAutosize from 'vue-textarea-autosize'
import { VNode, VNodeDirective, DirectiveFunction } from 'vue'
import { ENTER } from '@/components/Shortcuts/keyboards'

Vue.use(VueTextareaAutosize)

@Component({
  directives: {
    focus: {
      update: (
        el: HTMLElement,
        { value }: VNodeDirective,
        { context }: VNode
      ) => {
        if (!context) {
          return
        }
        if (!value) {
          context.$nextTick(() => {
            el.blur()
          })
          return
        }
      }
    }
  }
})
export default class CardInput extends Vue {
  @Prop()
  private handleSubmit!: (text: string) => void
  @Prop()
  private handleBlur!: () => void
  @Prop({ default: '' })
  private initial!: string
  @Prop({ default: false })
  private isNew!: boolean

  private value: string = this.initial
  private editing: boolean = true
  private isCancel: boolean = false

  private mounted() {
    const $el = (this.$refs.input as Vue).$el as HTMLElement
    $el.focus()
  }

  private doneEdit(): void {
    if (
      (this.isCancel && !this.isNew) ||
      (this.initial === this.value && this.value)
    ) {
      this.isCancel = false
      this.handleBlur()
      return
    }
    if (this.isCancel && this.isNew) {
      this.isCancel = false
      this.value = ''
    }
    this.value = this.value.trim()
    this.handleSubmit(this.value)
    this.handleBlur()
  }

  private onEnter(e: KeyboardEvent): void {
    if (!this.value) {
      return
    }
    this.editing = false
  }

  private onEsc(): void {
    this.isCancel = true
    this.editing = false
  }

  private stopKeyEvent(e: KeyboardEvent): void {
    if (!this.value && e.keyCode === ENTER && !e.shiftKey) {
      return
    }
    e.stopPropagation()
  }

  private stopEvent(e: ClipboardEvent): void {
    e.stopPropagation()
  }
}
